import {adminHttpClient} from "../commons/adminHttpClient";

const deleteAdvertisementAudit = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/AdvertisementAudits/Delete`, {
        data:{id : id}
    })
}

export default deleteAdvertisementAudit;